<template>
	<div class="is-screen-cover has-z-maximum is-centered is-semi-transparent is-pointerless has-background-black">
		<slot>
			<label v-if="value" class="is-size-1 has-text-info has-text-weight-bold">
				{{ value }}
			</label>
		</slot>
	</div>
</template>

<script>
export default {
	name: 'DpScreenCover',
	props: {
		value: { type: String, default: null },
	},
};
</script>
